import React from "react";
import { Link } from "react-router-dom";

export const CompleteTheSetCard = ({ set, onAddBoth }) => (
  <div className="mt-6 border border-[#1a1814]/15 bg-[#efe6db]/60 p-5" data-testid="complete-the-set">
    <div className="flex items-center justify-between mb-4">
      <div>
        <div className="micro-label text-[#1a1814]/60">Complete the Set</div>
        <div className="font-display text-2xl mt-1">{set.name}</div>
        <div className="text-xs italic text-[#1a1814]/65 mt-1">{set.tagline}</div>
      </div>
      <div className="text-right">
        <div className="text-xs text-[#1a1814]/50 line-through">£{set.full_price.toFixed(2)}</div>
        <div className="font-serif text-2xl text-[#1a1814]">£{set.bundle_price.toFixed(2)}</div>
        <div className="micro-label text-[#1a1814] mt-0.5">Save £{set.discount.toFixed(2)}</div>
      </div>
    </div>
    <Link to={`/shop/${set.partner.slug}`} className="flex gap-3 items-center mb-4 group hover:opacity-90" data-testid={`set-partner-${set.partner.id}`}>
      <img
        src={set.partner.image}
        alt={set.partner.name}
        style={{ objectPosition: set.partner.image_position || "center" }}
        className="w-14 h-16 object-cover bg-[#efe6db]"
      />
      <div className="flex-1">
        <div className="font-serif text-base group-hover:underline underline-offset-4 decoration-[0.5px]">{set.partner.name}</div>
        <div className="text-xs text-[#1a1814]/60 italic">{set.partner.tagline}</div>
      </div>
      <div className="font-serif text-base">£{set.partner.price.toFixed(2)}</div>
    </Link>
    <button
      type="button"
      onClick={onAddBoth}
      className="w-full border border-[#1a1814] bg-[#f0e9e1] text-[#1a1814] py-4 micro-label hover:bg-[#1a1814] hover:text-[#f0e9e1]"
      data-testid="add-set-btn"
    >
      Add Both — Save £{set.discount.toFixed(2)}
    </button>
  </div>
);
